import { Component, Input, inject } from "@angular/core";
import { ThirdPartyModel } from "@models/thirdparty/ThirdpartyModel";
import { IncidentLinkModel } from "@app/incident/models/incident-link.model";
import { IncidentThirdPartyService } from "@app/incident/services/incident-thirdparty.service";
import moment from "moment";
import { IncidentLinkableComponent } from "@app/incident/incident-linkable/incident-linkable.component";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/thirdparty/i18n/scope";

@Component({
    selector: "thirdparty-incidents",
    templateUrl: "./thirdparty-incidents.component.html",
    styleUrls: ["./thirdparty-incidents.component.scss"],
    imports: [IncidentLinkableComponent],
})
export class ThirdPartyIncidentsComponent {
    private incidentThirdPartyDS = inject(IncidentThirdPartyService);
    private _translation = injectTranslation(scope);

    @Input() model: ThirdPartyModel;
    @Input() disabled;

    linked: IncidentLinkModel[];
    isLoading = true;

    async load() {
        if (!this.model) {
            return;
        }

        await this._translation.ready();

        this.isLoading = true;

        this.incidentThirdPartyDS.getLinkedIncidentsAsync(this.model.Guid).subscribe((data) => {
            const mappedIncidents: IncidentLinkModel[] = [];
            if (data) {
                data.forEach((item) => {
                    item.displayItems = [];

                    item.displayItems.push({
                        Header: this._translation.t("incidents.isAffectedByHeader"),
                        Value: item.isAffectedBy
                            ? this._translation.t("incidents.yes")
                            : this._translation.t("incidents.no"),
                    });
                    item.displayItems.push({
                        Header: this._translation.t("incidents.isCausedByHeader"),
                        Value: item.isCausedBy
                            ? this._translation.t("incidents.yes")
                            : this._translation.t("incidents.no"),
                    });
                    item.displayItems.push({
                        Header: this._translation.t("incidents.descriptionHeader"),
                        Value: item.description,
                    });

                    item.displayItems.push({
                        Header: this._translation.t("incidents.statusHeader"),
                        Value: item.status,
                    });

                    if (item.due_Date !== null && item.due_Date !== undefined) {
                        const due_Date = moment(item.due_Date).format("DD-MM-YYYY");

                        item.displayItems.push({
                            Header: this._translation.t("incidents.dueDateHeader"),
                            Value: due_Date,
                        });
                    } else {
                        item.displayItems.push({
                            Header: this._translation.t("incidents.dueDateHeader"),
                            Value: null,
                        });
                    }

                    if (item.date_Occurred !== null && item.date_Occurred !== undefined) {
                        const date_Occurred = moment(item.date_Occurred).format("DD-MM-YYYY");

                        item.displayItems.push({
                            Header: this._translation.t("incidents.dateOccurredHeader"),
                            Value: date_Occurred,
                        });
                    } else {
                        item.displayItems.push({
                            Header: this._translation.t("incidents.dateOccurredHeader"),
                            Value: null,
                        });
                    }
                    mappedIncidents.push(item);
                });
            }
            this.linked = mappedIncidents;
            this.isLoading = false;
        });
    }
}
